const styles = theme => ({
  detailsWrapper: {
    padding: '24px',
  },
  marginTop: { marginTop: '15px' },
  marginBottom: {
    marginBottom: '24px',
    border: `1px solid ${theme.palette.secondary.disableLightGray}`,
    overflow: 'hidden',
  },
  titleHead: {
    background: '#F8F8F8',
    color: '#342D3D',
    padding: '10px 16px',
    [theme.breakpoints.up('sm')]: {
      borderBottom: '1px solid #CED1D6',
    },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '16px',
      fontWeight: '600',
    },
  },
  title: {
    fontWeight: '600',
    marginBottom: '5px',
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  itemGrid: {
    '& p': {
      fontSize: '1em',
      '&:first-child': {
        fontSize: '14px',
      },
    },
  },
  initiateservicedtaile: {
    display: 'grid',
    gridTemplateColumns: 'auto',
    gap: '9px',
    position: 'relative',
    '& $textHolder': {
      [theme.breakpoints.down('sm')]: {
        padding: '0 15px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      gap: '15px',
    },
  },
  darkgreen: {
    color: '#fff',
    background: '#1C999B',
  },
  silver: {
    color: '#8C9099',
    background: '#EBEEF3',
    border: '1px solid #8C9099',
  },
  info: {
    color: theme.palette.primary.infoBlue,
    border: `1px solid ${theme.palette.primary.infoBlue}`,
    background: theme.palette.primary.infoBlueLight,
  },
  initibadges: {
    marginLeft: '5px',
  },
  ownerShipType: {
    color: theme.palette.primary.adgmInfo,
    border: `1px solid ${theme.palette.primary.adgmInfo}`,
    background: theme.palette.primary.infoBlueLight,
  },
  strongText: {
    fontSize: '14px',
    fontWeight: '600',
    marginTop: '5px',
  },
  dangerLight: {
    color: '#B9350B',
    background: '#FDF0ED',
  },
  warning: {
    color: theme.palette.primary.warningMango,
    border: `1px solid ${theme.palette.primary.warningMango}`,
    background: theme.palette.primary.warningMangoLight,
  },
  error: {
    color: theme.palette.primary.dangerRed,
    border: `1px solid ${theme.palette.primary.dangerRed}`,
    background: theme.palette.primary.dangerRedLight,
  },
  dim: {
    color: theme.palette.primary.darkgray,
    border: `1px solid ${theme.palette.primary.darkgray}`,
    background: theme.palette.primary.borderColor,
  },
  '@media (min-width: 768px)': {
    titleHead: {
      padding: '16px 24px',
      '& h1': {
        fontSize: '20px',
      },
    },
    title: {
      fontSize: '20px',
    },
  },
  '@media (max-width: 767px)': {
    titleHead: {
      flexWrap: 'wrap',
    },
  },
  '@media (min-width: 960px)': {
    initiateservicedtaile: {
      gridTemplateColumns: '61px auto',
    },
    Title: {
      fontSize: '1.25rem',
    },
    strongText: {
      fontSize: '18px',
    },
  },
  [theme.breakpoints.down('sm')]: {
    titleHead: {
      padding: '16px 20px',
    },
    propertDetailsContainer: {
      border: 'none',
      borderRadius: '0',
      margin: 0,
      boxShadow: 'none',
    },
    detailsWrapper: {
      padding: '16px',
    },
    itemGrid: {
      borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
      margin: 0,
      padding: '16px',
      '&:last-child': {
        borderBottom: 'none',
      },
    },
  },
  [theme.breakpoints.down('xs')]: {
    detailsWrapper: {
      padding: '0px',
    },
    itemGrid: {
      '& p': {
        fontSize: '12px',
        fontWeight: '500',
        '&:first-child': {
          fontSize: '12px',
          fontWeight: '400',
        },
      },
    },
    gridContainer: {
      padding: '16px',
    },
  },
  gridContainer: {},
});
export default styles;
